import * as React from 'react'
import * as Snippets from 'snippets'

export class CustomCarouselArrows extends React.PureComponent<CustomCarouselArrows.Props> {
  public constructor(props) {
    super(props)
  }
  render() {
    return (
      <>
        <button className={'outline-none opacity-30 hover:opacity-100 mr-2-2'} onClick={this.props.prev}>
          <span className={'block'}>
            <Snippets.Icon name={'chevron_left'} width={18} label={'next slide'}/>
          </span>
        </button>
        <button className={'outline-none opacity-30 hover:opacity-100'} onClick={this.props.next}>
          <span className={'block'}>
            <Snippets.Icon name={'chevron_right'} width={18} label={'previous slide'}/>
          </span>
        </button>
      </>
    )
  }
}

export namespace CustomCarouselArrows {
  export interface Props {
    prev: () => void;
    next: () => void;
  }
}